var _path, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGauge2(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 165,
    viewBox: "0 0 266 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8454 7.41234C88.0063 8.00747 86.9979 9.98081 87.593 11.8199C88.1881 13.659 90.1615 14.6674 92.0006 14.0723C117.919 5.68511 145.835 5.76947 171.702 14.3131C173.537 14.9194 175.517 13.9229 176.123 12.0874C176.729 10.2519 175.733 8.27255 173.897 7.66632C146.618 -1.34372 117.179 -1.43268 89.8454 7.41234ZM179.766 13.2472C180.544 11.4778 182.61 10.6742 184.379 11.4523C210.677 23.0177 232.609 42.657 246.995 67.5238C247.963 69.1969 247.392 71.338 245.718 72.306C244.045 73.274 241.904 72.7024 240.936 71.0292C227.294 47.4496 206.498 28.8268 181.561 17.8601C179.792 17.0819 178.988 15.0167 179.766 13.2472ZM247.41 75.2877C249.16 74.4676 251.244 75.2219 252.064 76.9723C264.252 102.988 267.838 132.208 262.303 160.399C261.931 162.296 260.091 163.531 258.194 163.159C256.298 162.786 255.062 160.947 255.434 159.05C260.683 132.319 257.282 104.611 245.725 79.9419C244.905 78.1915 245.66 76.1077 247.41 75.2877ZM17.5716 71.5739C15.9096 70.5869 15.3624 68.4394 16.3494 66.7774C31.0186 42.0762 53.1727 22.6881 79.6007 11.4233C81.3789 10.6653 83.4348 11.4924 84.1928 13.2706C84.9507 15.0488 84.1236 17.1048 82.3454 17.8627C57.2854 28.5445 36.2779 46.929 22.368 70.3517C21.381 72.0137 19.2336 72.5609 17.5716 71.5739ZM4.51376 160.361C4.96058 162.242 6.84736 163.404 8.728 162.957C10.6086 162.51 11.771 160.623 11.3242 158.743C5.02721 132.239 7.33395 104.418 17.91 79.3136C18.6605 77.5322 17.8247 75.4797 16.0434 74.7293C14.262 73.9788 12.2095 74.8146 11.4591 76.5959C0.305713 103.071 -2.12694 132.41 4.51376 160.361Z",
    fill: "url(#paint0_radial_2_1072)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2_1072)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.585,
    cy: 35.585,
    r: 10.5391,
    transform: "rotate(0.25 44.585 35.585)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.585,
    cy: 35.585,
    r: 10.5391,
    transform: "rotate(0.25 44.585 35.585)",
    stroke: "#AE65B0",
    strokeWidth: 7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2_1072",
    x: 8.58934,
    y: 12.7633,
    width: 71.9912,
    height: 71.9912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.3913
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.3913
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_1072"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1739
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.9783
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2_1072",
    result: "effect2_dropShadow_2_1072"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2_1072",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2_1072",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.49983 164) scale(250.5 312.633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#672BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA572"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge2);
export default __webpack_public_path__ + "assets/media/gauge-2.fb8782f6.svg";
export { ForwardRef as ReactComponent };